module.exports = __webpack_public_path__ + "img/member-invite-authority-check.67a9a153.svg";